import React from "react"
import styled from "styled-components"
import Image from "gatsby-image"

const SmallItem = ({ item, image }) => {
  return (
    <Wrapper>
      
      <div className="text">
        <div className="title">{item.title}</div>
        <p>{item.text}</p>
      </div>
      <div className="image">
        <Image fluid={image.childImageSharp.fluid} alt={item.title} />
      </div>
    </Wrapper>
    
  )
}

const Wrapper = styled.article`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  .title {
    font-size: 16px;
    line-height: 190%;
  }
  p {
    margin-top: 18px;
    font-size: 12px;
    line-height: 190%;
  }
  .image {
    display: block;
    width: 85%;
    margin: 26px auto;
    
  }
  .text {
    
  }
  @media screen and (min-width: 568px) {
    .image{width: 50%}
  }
  @media screen and (min-width: 768px) {
    flex-direction: row;
    gap:20px; 
    .text{flex-basis: 70%}
    .image{flex-basis: 30%}
    
  }
  @media screen and (min-width: 1024px) {
    
  }
  @media screen and (min-width: 1025px) {    
    margin-top: 50px;
    flex-direction: column;
    
    .image{order: -1; width: 327px;}
    .title {
    font-size: 1.5rem;
    line-height: 2.25rem;
  }
  p {
    margin-top: 1.5rem;
    font-size: 1rem;
  }
  }
    
`

export default SmallItem
